module.exports = __webpack_public_path__ + "img/river_painter6.68b70638.png";